import apiMiddleware from "../../../api/apiMiddleware";

export const listRentalsAdmin = async (page = 1, filters = {}, perPage = 10) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("per_page", perPage);

  if (filters.search) params.append("search", filters.search);
  if (filters.status !== undefined && filters.status !== "all")
    params.append("status", filters.status);
  if (filters.is_approved !== undefined && filters.is_approved !== "all")
    params.append("is_approved", filters.is_approved);
  if (filters.supplier_id && filters.supplier_id !== "all")
    params.append("supplier_id", filters.supplier_id);

  const response = await apiMiddleware.get(`/rentals-admin?${params.toString()}`);
  return response.data;
};

export const createRentalAdmin = async (formData) => {
  const response = await apiMiddleware.post("/rentals-admin", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const getRentalAdminById = async (id) => {
  const response = await apiMiddleware.get(`/rentals-admin/${id}`);
  return response.data;
};

export const approveOrRejectRental = async ({ rental_item_id, is_approved, rejection_reason }) => {
  const body = {
    rental_item_id,
    is_approved,
  };
  if (rejection_reason != null && String(rejection_reason).trim() !== "") {
    body.rejection_reason = String(rejection_reason).trim();
  }
  const response = await apiMiddleware.post(`/approve-or-reject-rental`, body);
  return response.data;
};

export const updateRentalAdmin = async (id, data) => {
  if (data instanceof FormData) {
    data.append("_method", "PUT");
    const response = await apiMiddleware.post(`/rentals-admin/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }
  const response = await apiMiddleware.put(`/rentals-admin/${id}`, data);
  return response.data;
};

export const updateRentalAdminPricing = async (id, data) => {
  const response = await apiMiddleware.put(`/rentals-admin/${id}/pricing`, data);
  return response.data;
};

export const updateRentalAdminUnit = async (rentalItemId, unitId, data) => {
  const response = await apiMiddleware.patch(
    `/rentals-admin/${rentalItemId}/units/${unitId}`,
    data
  );
  return response.data;
};

export const getRentalCategoriesMaster = async () => {
  const response = await apiMiddleware.get(`/rental-categories-master`);
  return response.data;
};

export const getRentalSubCategoriesMaster = async (categoryId) => {
  const response = await apiMiddleware.get(
    `/rental-sub-categories-master/${categoryId}`
  );
  return response.data;
};

export const getRentalFeaturesMaster = async (formType) => {
  const q =
    formType !== undefined && formType !== null && formType !== ""
      ? `?form_type=${encodeURIComponent(formType)}`
      : "";
  const response = await apiMiddleware.get(`/rental-features-master${q}`);
  return response.data;
};

export const createRentalFeature = async (data) => {
  const response = await apiMiddleware.post(`/rental-features`, data);
  return response.data;
};

/** Admin rental wizard (same payloads as supplier; uses rentals-admin routes) */
export const getRentalAdminFAQs = async (itemId) => {
  const response = await apiMiddleware.get(`/rentals-admin/${itemId}/faqs`);
  return response.data;
};

export const createRentalAdminFAQ = async (data) => {
  const response = await apiMiddleware.post(`/rentals-admin/faqs`, data);
  return response.data;
};

export const updateRentalAdminFAQ = async (id, data) => {
  const response = await apiMiddleware.put(`/rentals-admin/faqs/${id}`, data);
  return response.data;
};

export const deleteRentalAdminFAQ = async (id) => {
  const response = await apiMiddleware.delete(`/rentals-admin/faqs/${id}`);
  return response.data;
};

export const getRentalAdminTerms = async (itemId) => {
  const response = await apiMiddleware.get(`/rentals-admin/${itemId}/terms`);
  return response.data;
};

export const createRentalAdminTerms = async (data) => {
  const response = await apiMiddleware.post(`/rentals-admin/terms`, data);
  return response.data;
};

export const getRentalAdminBlockedDates = async (itemId) => {
  const response = await apiMiddleware.get(`/rentals-admin/${itemId}/blocked-dates`);
  return response.data;
};

export const createRentalAdminBlockedDate = async (data) => {
  const response = await apiMiddleware.post(`/rentals-admin/blocked-dates`, data);
  return response.data;
};

export const deleteRentalAdminBlockedDate = async (id) => {
  const response = await apiMiddleware.delete(`/rentals-admin/blocked-dates/${id}`);
  return response.data;
};

export const uploadRentalAdminGalleryImages = async (rentalItemId, formData) => {
  const response = await apiMiddleware.post(
    `/rentals-admin/${rentalItemId}/gallery/upload`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};

export const deleteRentalAdminGalleryImage = async (imageId) => {
  const response = await apiMiddleware.delete(`/rentals-admin/gallery-images/${imageId}`);
  return response.data;
};

export const setRentalAdminPrimaryImage = async (imageId) => {
  const response = await apiMiddleware.post(`/rentals-admin/gallery-images/${imageId}/set-primary`);
  return response.data;
};

/** Supplier-parity aliases for shared AddRentalTabs components */
export const getRentalItemById = getRentalAdminById;
export const createRentalItem = createRentalAdmin;
export const updateRentalItem = updateRentalAdmin;
export const storeRentalItemPricing = updateRentalAdminPricing;
export const updateRentalItemPricing = updateRentalAdminPricing;
export const getRentalTerms = getRentalAdminTerms;
export const createRentalTerm = createRentalAdminTerms;
export const getRentalFAQs = getRentalAdminFAQs;
export const createRentalFAQ = createRentalAdminFAQ;
export const updateRentalFAQ = updateRentalAdminFAQ;
export const deleteRentalFAQ = deleteRentalAdminFAQ;
export const getRentalBlockedDates = getRentalAdminBlockedDates;
export const createRentalBlockedDate = createRentalAdminBlockedDate;
export const deleteRentalBlockedDate = deleteRentalAdminBlockedDate;
export const uploadRentalGalleryImages = uploadRentalAdminGalleryImages;
export const deleteRentalGalleryImage = deleteRentalAdminGalleryImage;
export const setRentalPrimaryImage = setRentalAdminPrimaryImage;

export const listRentalWeekdayPrices = async (rentalItemId) => {
  const response = await apiMiddleware.get(`/rentals-admin/${rentalItemId}/weekday-prices`);
  return response.data;
};

export const upsertRentalWeekdayPrice = async (rentalItemId, data) => {
  const response = await apiMiddleware.post(`/rentals-admin/${rentalItemId}/weekday-prices`, data);
  return response.data;
};

export const deleteRentalWeekdayPrice = async (weekdayPriceId) => {
  const response = await apiMiddleware.delete(`/rentals-admin/weekday-prices/${weekdayPriceId}`);
  return response.data;
};

